import { render } from "./vSelectCoklu.vue?vue&type=template&id=25ecae37"
import script from "./vSelectCoklu.vue?vue&type=script&lang=js"
export * from "./vSelectCoklu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__